const IncidentResponsePolicy = () => {
  return (
    <div className="overflow-hidden">
      <section className="relative py-24 hero-gradient mesh-gradient">
        <div className="absolute top-20 right-10 w-72 h-72 bg-purple-400/20 rounded-full blur-3xl" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold font-['Outfit'] tracking-tighter mb-6">
              Incident Response Policy
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Jnan Innovative IT Solutions maintains an incident response process to address security incidents, including unauthorized access, data leakage, and system compromises.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            <p>
              Jnan Innovative IT Solutions maintains an incident response process to address security incidents, including unauthorized access, data leakage, and system compromises.
            </p>

            <h2>1. Incident Response Steps</h2>
            <p>Detection and identification of suspicious activities, including unauthorized access, unusual API activity, data export anomalies, privilege escalation, and potential exposure of Amazon SP-API data or customer PII.</p>
            <br />

            <h2>2. Immediate Containment</h2>
            <p>Immediate containment of affected systems, accounts, credentials, tokens, or integrations to limit further exposure.</p>
            <br />

            <h2>3. Investigation</h2>
            <p>Investigation and root cause analysis using audit logs, system evidence, access records, and affected data inventories.</p>
            <br />

            <h2>4. Remediation</h2>
            <p>Remediation through patches, credential rotation, token revocation, access removal, configuration changes, and security improvements.</p>
            <br />

            <h2>5. Recovery</h2>
            <p>Recovery of affected systems and services.</p>
            <br />

            <h2>6. Documentation and Review</h2>
            <p>Documentation and post-incident review.</p>
            <br />

            <h2>7. Notification and Follow-Up</h2>
            <p>
              Where required by law, contract, or platform policy, affected customers, partners, or platform providers are notified. Corrective actions are tracked to completion to reduce recurrence risk.
            </p>
            <br />

            <p>
              Security incidents are managed by authorized personnel and corrective actions are implemented to prevent recurrence.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default IncidentResponsePolicy;
